import React from 'react';
import {useHistory, useLocation} from 'react-router-dom';
// @redux
import {connect} from 'react-redux';
// @rbac
import { useB2BPermissions } from '../../../../context/B2BPermissionsContext';
// @design-system
import ChipFilter from '../../../../design-system/components/Chip/ChipFilter';
import LoaderContent from '../../../../design-system/components/Loader/LoaderContent';
import NothingFound from '../../../../components/NothingFound/NothingFound';
import Toast from '../../../../design-system/components/Toast/Toast';
import Table from '../../../../design-system/components/Table/Table';
import Select from '../../../../design-system/components/Form/Select/Select';
import dateFormat from "../../../../design-system/utils/dateFormat";
import Dropdown from '../../../../design-system/components/Dropdown/Dropdown';
import TitleBanner from '../../../../design-system/components/Banners/TitleBanner';
import TextField from '@material-ui/core/TextField';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import {ISO_DATE_FORMAT} from "../../../../design-system/constants/date-formats";
// @material-core
import {
  Icon,
  Grid,
  Box,
  Button,
  Card,
  CardContent,
  Modal,
  CardHeader
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
// @ThirtyParty
import {clone, isEmpty, isNil} from 'ramda';
import queryString from 'query-string'
import clsx from 'clsx';
import writeXlsxFile from 'write-excel-file'
import moment from 'moment';
// @local
import {membresias, excelMembershipColumns} from '../ColumnsTable';
import {commonModuleStyles} from '../../../../assets/styles/jss/pages/common/CommonModuleStyles'   


// SDK
import {MembershipManagmentB2BService} from '@sdk-point/talisis'

const MembershipManagmentB2BServiceSDK = new MembershipManagmentB2BService(process.env.REACT_APP_ENV_V2, process.env.REACT_APP_X_API_KEY_V2);

const MembershipTablePage = (props) => {

  const classes = commonModuleStyles();
  const history = useHistory();
  const location = useLocation();
  const { filterCompaniesByScope, assignedCompanyName, autoSelectCompany } = useB2BPermissions();

  const [toast, setToast] = React.useState({toastProps: {message: '', open: false}})
  const [columns] = React.useState(membresias)
  const [loading, setLoading] = React.useState(false);
  const [state, setState] = React.useState({data: [], totalPages: 0, dataSource: []})
  const [inputSearch, setInputSearch] = React.useState('');
  const [selectedFilters, setSelectedFilters] = React.useState({});
  const [filters, setFilters] = React.useState([]);
  const [selectedList] = React.useState([]);
  const [showFilter, setShowFilter] = React.useState(false);
  const [, setFilteCss] = React.useState({});
  const [openModalDetails, setOpenModalDetials] = React.useState({payload: {}, show: false});
  const [openStudentDetails, setOpenStudentDetails] = React.useState(false);

  const [isCheckBox, setIsCheckBox] = React.useState(false);
  // Criterio activo del "Buscar por" dentro de Filtro Avanzado. Según el valor se
  // habilita un control distinto: emailAddress -> textbox, createdBy -> listado
  // (catálogo de solicitantes), createdAt -> calendario. Empresa NO entra aquí: es
  // el primer filtro, obligatorio, y vive fuera del "Buscar por".
  const [searchBy, setSearchBy] = React.useState('emailAddress');
  const [catalogues, setCatalogues] = React.useState({companyTag: [],createdBy: []});
  const [loadingCompany, setLoadingCompany] = React.useState(false);
  const [loadingCreateBy, setLoadingCreateBy] = React.useState(false)
  const [, setDisabledOptions] = React.useState(true);


  const [messageTable] = React.useState({
    default: {
      caption: 'Selecciona tu criterio de búsqueda dando click en el botón de Filtrado avanzado.',
      subtitle: 'Filtra por correo,nombre del solicitante, fecha de alta ó empresa.'
    },
    data: {
      caption: 'Selecciona tu criterio de búsqueda dando click en el botón de Filtrado avanzado.',
      subtitle: 'Filtra por correo,nombre del solicitante, fecha de alta ó empresa.'
    }
  });


  const valueFilterLabels = {
    createdBy: 'Solicitado Por',
    createdAt: 'Fecha',
    companyTag: 'Empresa',
  };

  const valueFilterQueryStringURL = {
    createdBy: 'createdBy',
    createdAt: 'createdAt',
    companyTag: 'companyTag',
    emailAddress: 'emailAddress',
  };

  // Opciones del selector "Buscar por". El id coincide con el name del filtro que
  // controla cada criterio, para habilitar el control correspondiente.
  const SEARCH_BY_OPTIONS = [
    { id: 'emailAddress', label: 'Correo' },
    { id: 'createdBy', label: 'Solicitado Por' },
    { id: 'createdAt', label: 'Fecha de Alta' },
  ];

   React.useEffect(() => {
      const params = {...selectedFilters}
      history.push({search: new URLSearchParams(params).toString()});
      return () => {
      }
      
    }, [selectedFilters]);
  
    React.useEffect(() => {
      // Start empty on mount: do NOT restore filters from the URL nor auto-query.
      // The report must remain empty until the user explicitly selects a company
      // (and optionally other filters) and presses "Aplicar".
      setLoading(false)

      // Load only the "Solicitado Por" catalog here (independent of scope).
      setLoadingCreateBy(true)
      getCreateBy()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Load/re-load the company catalog whenever the user's scope changes. The
    // permissions load is async and may resolve after mount, so re-filtering is
    // required for a recently assigned company to appear.
    React.useEffect(() => {
      setLoadingCompany(true)
      getCompany()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignedCompanyName.join('|')]);

    const getCreateBy = async () => {
      try {
    
        const {data} = await MembershipManagmentB2BServiceSDK.getCatalogCreateBy()
        
        // Drop entries without a creator_id: the Select requires a non-null id.
        const createdBy = (data || [])
          .filter(item => !isNil(item.creator_id))
          .map(item => ({
            id: item.creator_id,
            label: item.creator_name,
            value: item.creator_id,
          }))
        setCatalogues(prevState => ({...prevState, createdBy}))
  
      } catch (err) {
        if (isNil(err)) {
          setToast({toastProps: {severity: "error", open: true, message: "Ops! Ha ocurrido un error"}})
        } else {
          setToast({toastProps: {severity: "error", open: true, message: err.message}})
        }
      }
      setLoadingCreateBy(false)
    }
 
   const getCompany = async () => {
      try {
    
        const {data} = await MembershipManagmentB2BServiceSDK.getCatalogCompanies({type: 'company'})
        // Restrict to the user's configured companies before mapping.
        const scoped = filterCompaniesByScope(data || [])
        const companyTag =   scoped.map(item => ({
          id: item.id, 
          label: item.display_name,
          value: item.id,
          tag: item.tag
          }))
        setCatalogues(prevState => ({...prevState, companyTag}))

        // Autoselección: cuando el usuario tiene UNA sola empresa externa, el
        // contexto entrega `autoSelectCompany`. En ese caso el selector se precarga
        // con esa empresa y se consulta el reporte directamente (no se queda vacío).
        // El match contra el catálogo es por nombre normalizado (el id del scope no
        // necesariamente coincide con el id del catálogo). Si no hay autoselección,
        // se mantiene el comportamiento original: reporte vacío hasta que el usuario
        // elija una empresa.
        if (autoSelectCompany) {
          const normalize = (n) => (n || '').toString().trim().toUpperCase();
          const match = companyTag.find(
            (c) => normalize(c.label) === normalize(autoSelectCompany.company_name)
          );
          if (match) {
            const nextFilters = {...selectedFilters, companyTag: match.value};
            setSelectedFilters(nextFilters);
            setFilters(prev => [
              ...prev.filter(f => !('companyTag' in f)),
              {companyTag: match.value, label: `${valueFilterLabels.companyTag}: ${match.label}`},
            ]);
            setLoading(true);
            getAllRequests(nextFilters);
          }
        }
      } catch (err) {
        if (isNil(err)) {
          setToast({toastProps: {severity: "error", open: true, message: "Ops! Ha ocurrido un error"}})
        } else {
          setToast({toastProps: {severity: "error", open: true, message: err.message}})
        }
      }
      setLoadingCompany(false)
    }

    

    
    
  const getAllRequests = async (overrideFilters) => {
      try {
        let payload = overrideFilters || (isEmpty(selectedFilters) ? queryString.parse(location.search) : selectedFilters)

        // A company is MANDATORY. The report lambda is not scope-aware, so a query
        // without companyTag would return records outside the user's scope. Do not
        // call the lambda until a company is chosen.
        if (isEmpty(payload) || isNil(payload.companyTag) || payload.companyTag === '') {
          setState({data: [], totalPages: 0, dataSource: []})
          setLoading(false)
          return
        }

        setDisabledOptions(true)
        

        const response = await MembershipManagmentB2BServiceSDK.getCatalogUsersReport(payload);
        const data = response?.data
        const registros = Array.isArray(data) ? data : []

        setLoading(false)
        setDisabledOptions(false)
        const dataFormat = registros.map(row => ({
          ...row,
          createdBy: payload.createdBy,
          createdAt: payload.createdAt,
          companyTag:payload.companyTag,
        }))

        setState({data: dataFormat, dataSource: dataFormat})


      } catch (err) {
        setLoading(false)
        setDisabledOptions(false)
        if (isNil(err)) {
          setToast({toastProps: {severity: "error", open: true, message: "Ops! Ha ocurrido un error"}})
        } else {
          setToast({toastProps: {severity: "error", open: true, message: err.message}})
        }
      }
    }

  const handleChangeFilter = (e) => {
      let {target: {value, name, type}} = e

      // NOTA: antes aquí se recargaban los catálogos (getCreateBy/getCompany) en
      // CADA cambio de filtro. Eso era incorrecto: los catálogos no dependen del
      // filtro elegido (se cargan una vez al montar), y peor aún, getCompany ejecuta
      // su bloque de autoselección que reescribía selectedFilters desde un closure
      // viejo, pisando el filtro recién seleccionado (createdBy/createdAt) y dejando
      // solo companyTag. Por eso "solo filtraba por empresa". Se eliminaron.

      if ( type === 'createdAt'){
        value = dateFormat(value || '', ISO_DATE_FORMAT, 0, ['DD/MM/YYYY', 'YYYY-MM-DD'])
      }

      // Buscar el label descriptivo del catálogo
      let displayLabel = value;
      if (name === 'createdBy') {
        const found = catalogues.createdBy.find(item => String(item.id) === String(value));
        if (found) displayLabel = found.label || found.name || value;
      } else if (name === 'companyTag') {
        const found = catalogues.companyTag.find(item => String(item.id) === String(value));
        if (found) displayLabel = found.label || found.name || value;
      }

      let filter = {};
      filter[name] = value;
      filter['label'] = `${valueFilterLabels[name]}: ${displayLabel}`;

      // Use functional updates so chaining filters (e.g. "Solicitado Por" then
      // "Empresa") never overwrites a previously set key from a stale closure.
      // Replace any existing chip/entry of the same type before adding the new one.
      setFilters(prev => [...prev.filter(f => !(name in f)), filter]);
      setSelectedFilters(prev => ({...prev, [valueFilterQueryStringURL[name]]: value}));
    }
  

  const onChangeSearch = (e) => {
        e.preventDefault();
        const {target: {value}} = e
        let newInput = value.replace(/" "|\n|\t+/g, "")
        newInput = newInput.replace(/\s/g, "");
    
        setInputSearch(newInput);
        let newSelectedFilters = clone(selectedFilters)
        if (isEmpty(newInput) && newSelectedFilters.emailAddress !== undefined) {
          delete newSelectedFilters.emailAddress
        } else {
          newSelectedFilters.emailAddress = newInput
        }
        setSelectedFilters(newSelectedFilters);

        // Mantener sincronizado el chip de "Correo" para que sea VISIBLE y BORRABLE
        // (igual que Empresa / Solicitado Por / Fecha). Sin esto, el correo se
        // guardaba en selectedFilters pero no generaba chip, por lo que no se podía
        // quitar y el emailAddress viejo seguía ensuciando la búsqueda. Con texto ->
        // se agrega/reemplaza el chip; sin texto -> se quita.
        setFilters(prev => {
          const withoutEmail = prev.filter(f => !('emailAddress' in f));
          if (isEmpty(newInput)) return withoutEmail;
          return [...withoutEmail, { emailAddress: newInput, label: `Correo: ${newInput}` }];
        });
  }

  // Cambia el criterio del "Buscar por". Los filtros se ACUMULAN: cambiar de
  // criterio solo cambia qué control se muestra, SIN borrar los filtros ya
  // aplicados. Así el usuario puede ir agregando Empresa + Solicitado Por + Fecha +
  // Correo y todos se mandan juntos. Cada filtro se elimina individualmente con la
  // tachita (X) de su chip (ver handleDeleteChip). No se borra nada aquí.
  const handleChangeSearchBy = (e) => {
        setSearchBy(e.target.value);
  }

    const handleDeleteChip = (chipToDelete) => () => {
    const newFilters = filters.filter((chip) => JSON.stringify(chip) !== JSON.stringify(chipToDelete));
    setFilters(newFilters);
    const key = Object.keys(chipToDelete).find(k => k !== 'label');
    // Al quitar el chip de correo, también limpiar el texto del input.
    if (key === 'emailAddress') {
      setInputSearch('');
    }
    setSelectedFilters((prevState) => {
      const newState = {...prevState};
      delete newState[valueFilterQueryStringURL[key]];
      return newState;
    });
  }


  
  const handleFilter = () => {
    // "Empresa" is MANDATORY (anchors the user's scope — the report must never
    // query outside the companies the user is allowed to see). "Solicitado Por"
    // is OPTIONAL: with just a company the report returns every record of that
    // company; adding "Solicitado Por" narrows it further.
    if (isNil(selectedFilters.companyTag) || selectedFilters.companyTag === '') {
      setToast({toastProps: {severity: "warning", open: true, message: 'Seleccione una empresa para consultar el reporte.'}});
      return;
    }

    setLoading(true);
    setShowFilter(false);
    setFilteCss({});
    setState({data: [], dataSource: []});
    setIsCheckBox(false);
    getAllRequests();
  }

  const handledDownLoadExcel = async () => {


    try {

      setLoading(true);

      //const response = await DegreeServiceSDK.postStudentCertificateDetails(payload);

     /* if (!response.success) {
        handledToastFailed(response);
        setLoading(false);
        return
      }*/

      let  datasource= state.data

      await writeXlsxFile(datasource, {
        schema: excelMembershipColumns,
        fileName: `Reporte de Gestion de Membresias B2B ${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`
      })

      setLoading(false);
   
    } catch (err) {
      setToast({toastProps: {severity: "error", open: true, message: err.message}})
      setLoading(false);
    }

  }


  return (
    <>
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TitleBanner
          title="Gestión de Membresías B2B - Reporte"
          desc="Consulte el detalle de las membresías B2B creadas."
        />
      </Grid>
      <Grid item xs={12}>
        <Card>
          <CardContent>
          <Grid container spacing={2} alignItems="center">
            {/* Empresa: PRIMER filtro, siempre visible y obligatorio. Ancla el
                scope del reporte; sin empresa no se consulta. Lleva un botón
                "Buscar" al lado para consultar directo con solo la empresa, sin
                abrir el Filtro Avanzado. */}
            <Grid item xs={12} md={6}>
              <Box display="flex" alignItems="flex-end" style={{ gap: 8 }}>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Select
                    items={catalogues.companyTag}
                    margin="dense"
                    variant="outlined"
                    label="Empresa"
                    name="companyTag"
                    onChange={(e) => handleChangeFilter(e)}
                    disabled={!isNil(selectedFilters.companyTag) || !catalogues.companyTag.length}
                    loading={loadingCompany}
                    value={!isNil(selectedFilters.companyTag) ? selectedFilters.companyTag : ''}
                    size="medium"
                    fullWidth
                  />
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter()}
                  size="medium"
                  disabled={loading || isNil(selectedFilters.companyTag) || selectedFilters.companyTag === ''}
                  style={{ height: 44, minWidth: 110, flexShrink: 0, marginBottom: 4 }}
                >
                  Buscar
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box display="flex" justifyContent="flex-end" alignItems="center" style={{ gap: 12 }}>
                <Button
                  color="secondary"
                  variant={showFilter ? "contained" : "outlined"}
                  className={clsx(classes.button, showFilter ? classes.filterButton : classes.filterButtonOutlined)}
                  disabled={loading}
                  onClick={() => {
                    setShowFilter(!showFilter)
                  }}
                  size="small"
                  style={{ height: 40 }}
                >
                  <Typography variant='body2' noWrap> Filtro Avanzado</Typography>
                  <Icon className={clsx(showFilter ? "text-white" : "", "ri-equalizer-line", 'font-size-20')}
                        fontSize='small' style={{marginLeft: "6px"}}/>
                </Button>
                <Dropdown
                  text='Descargar Excel'
                  endIcon={<ArrowDropDownIcon className='font-size-24'/>}
                  style={{height: 40}}
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  disabled={loading}
                  onClick={() => handledDownLoadExcel()} 
                />
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <ChipFilter chipData={filters} handleDelete={(e) => handleDeleteChip(e)} />
            </Grid>
          </Grid>
          {showFilter && (
            <Box display="flex" alignItems="flex-end" style={{ marginTop: 16, gap: 16 }}>
              {/* "Buscar por": selecciona el criterio y, según él, se habilita el
                  control correspondiente a la derecha:
                    - Correo        -> textbox
                    - Solicitado Por -> listado (catálogo de solicitantes)
                    - Fecha de Alta  -> calendario (DatePicker)
                  Empresa NO está aquí: es el primer filtro (arriba), obligatorio. */}
              <Box style={{ flex: 1, minWidth: 0 }}>
                <Select
                  items={SEARCH_BY_OPTIONS}
                  margin="dense"
                  variant="outlined"
                  label="Buscar por"
                  name="searchBy"
                  onChange={handleChangeSearchBy}
                  value={searchBy}
                  size="medium"
                  fullWidth
                />
              </Box>

              {/* Control dinámico según el criterio elegido */}
              <Box style={{ flex: 1, minWidth: 0 }}>
                {searchBy === 'emailAddress' && (
                  <TextField
                    name="emailAddress"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    placeholder="Escribe el correo"
                    value={inputSearch}
                    onChange={onChangeSearch}
                  />
                )}
                {searchBy === 'createdBy' && (
                  <Select
                    items={catalogues.createdBy}
                    margin="dense"
                    variant="outlined"
                    name="createdBy"
                    onChange={(e) => handleChangeFilter(e)}
                    disabled={!catalogues.createdBy.length}
                    loading={loadingCreateBy}
                    value={!isNil(selectedFilters.createdBy) ? selectedFilters.createdBy : ''}
                    size="medium"
                    fullWidth
                  />
                )}
                {searchBy === 'createdAt' && (
                  <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="es">
                    <DatePicker
                      name="createdAt"
                      inputVariant="outlined"
                      margin="dense"
                      fullWidth
                      value={selectedFilters.createdAt ? moment(selectedFilters.createdAt, ISO_DATE_FORMAT).toDate() : null}
                      onChange={(date) => {
                        const formattedDate = dateFormat(date || '', ISO_DATE_FORMAT, 0, ['DD/MM/YYYY', 'YYYY-MM-DD']);
                        handleChangeFilter({ target: { name: 'createdAt', value: formattedDate, type: 'createdAt' } });
                      }}
                      format="DD/MM/YYYY"
                      placeholder="DD/MM/YYYY"
                      variant="dialog"
                      autoOk={false}
                      openTo="year"
                      views={['year', 'month', 'date']}
                      okLabel="OK"
                      cancelLabel="Cancel"
                      TextFieldComponent={(params) => <TextField {...params} />}
                    />
                  </MuiPickersUtilsProvider>
                )}
              </Box>

              <Box style={{ flex: 1 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleFilter()}
                  size="medium"
                  disabled={loading}
                  fullWidth
                  style={{ height: 40 }}
                >
                  Aplicar
                </Button>
              </Box>
            </Box>
          )}

          <LoaderContent loading={loading} minHeight={500}>
            {isNil(selectedFilters.companyTag) || selectedFilters.companyTag === '' ? (
              !loading && (
                <NothingFound
                  width='200px'
                  caption='Seleccione una empresa para consultar el reporte.'
                  subcaption='El reporte se filtra por la empresa que tenga configurada.'
                />
              )
            ) : state.data.length > 0 ? (
              <Table
                checkboxs={isCheckBox}
                maxHeight={'800px'}
                columns={columns}
                rows={state.data}
                rowSelectedList={selectedList}
                checkboxDisabledIcon={true}
              />
            ) : (
              !loading && (
                <NothingFound
                  width='200px'
                  caption={messageTable.data.caption}
                  subcaption={messageTable.data.subtitle}
                />
              )
            )}
          </LoaderContent>
        </CardContent>
      </Card>
      </Grid>
      </Grid>
      <Modal
        open={openModalDetails.show}
        className={classes.modal}
        onClose={() => setOpenModalDetials({payload: {}, show: false})}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          }
        }}
      >
        <Card className={classes.card}>
          <CardHeader
            action={
              <IconButton aria-label="go to back">
                <Icon className={clsx("ri-close-line", 'font-size-24')} style={{color: '#000000'}}/>
              </IconButton>
            }
          />
        </Card>
      </Modal>
      <Modal
        open={openStudentDetails}
        className={classes.modalStudent}
        disableScrollLock={false}
        onClose={() => setOpenStudentDetails(false)}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
          }
        }}
      >
        <Card className={classes.card}>
          <CardContent>
            {/* Contenido del modal de detalles del estudiante */}
          </CardContent>
        </Card>
      </Modal>
      <Toast
        {...toast.toastProps}
        duration={5000}
        onFinished={() => setToast({toastProps: {...toast.toastProps, open: false}})}
      />
    </>
  );
};

const mapStateToProps = (state) => ({...state.userReducer});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MembershipTablePage);
